export const enum FilterQuestion {
    ONDATE = "date",
    ONYEAREXPERTISE = "yearExpertise",
    FILTERWITHANSWER = "filterAnswer",
};
